(function ($) {

    "use strict";

    var Grid = function (el, options) {
        this.$wrapper = $(el);
        this.options = options;
        this.init();
    };

    Grid.prototype = {
        items: 0,
        first_load: true,
        products_count: 0,
        are_more: true,
        loading: true,
        init: function ()
        {
            this.appendOptions(); // attach options to the class object
            this.createCarouselControls();
            this.createMockup();
            this.getProducts();
            this.bindEvents();
        },
        // appendeo las opciones enviadas desde la vista
        appendOptions: function ()
        {
            var self = this;
            $.each(this.options, function(k, v) {
                self[k] = v; // this.options.foo = this.foo
            });
        },
        createCarouselControls: function () {
            var icon = '<svg class="carousel-control-icon" x="0px" y="0px" viewBox="0 0 17.262 28.857"><polyline fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="14.762,26.357 2.5,14.096 14.098,2.5 "></polyline></svg>',
                $prev = $('<a class="carousel-control-prev" role="button" data-slide="prev"><span class="sr-only">Anterior</span></a>'),
                $next = $('<a class="carousel-control-next" role="button" data-slide="next"><span class="sr-only">Siguiente</span></a>');
            this.$controls = $prev.add($next).prepend(icon);
        },
        createMockup: function () {
            this.$product = $('<div class="col products-item"/>');
        },
        // bindeo eventos
        bindEvents: function ()
        {
            var self = this;
            // mostrar mas productos
            $(window).scroll(function() {
                if (!self.loading && self.are_more) {
                    self.checkScrollOffset($(window).height()); // el parametro que le paso es la distancia en px antes del bottom de la grilla para que se ejecute
                }
            });
            this.$form.on('submit', function(e) {
                if (!$(this).find('[name="q"]').val()) {
                    e.preventDefault();
                }
            }).find('[name="q"]').on('input change', function() {
                this.value = this.value.replace('\\', '');
            });
        },
        // veo si llego al punto deseado para cargar mas productos automaticamente
        // el parametro que le paso es la distancia en px antes del bottom de la grilla para que se ejecute
        checkScrollOffset: function (diff) {
            var scroll_bottom = $(window).scrollTop() + $(window).height(),
                grid_bottom = this.$grid.offset().top + this.$grid.height(),
                offset = grid_bottom - scroll_bottom - diff;
            if (offset <= 0) {
                this.getProducts();
            }
        },
        // pide productos a la base de datos
        getProducts: function ()
        {
            var self = this,
                query = this.query.join('==='),
                post_data = { page: this.page, q: query, all: this.all };

            if (this.model_id) { post_data.model_id = this.model_id; }
            if (this.category_id) { post_data.category_id = this.category_id; }

            if ( ! this.first_load) {
                self.toggleLoadingStatus(true);
            }

            $.post("/api/products", post_data, function( data ) {
                self.are_more = data.has_more;
                self.products_count = data.products.length;
                if (data.products.length) {
                    $.each(data.products, function() {
                        var product = this;
                        product.gallery = [self.getImgSrc(product.id, product.front_image)];
                        if (product.back_image) {
                            product.gallery.push(self.getImgSrc(product.id, product.back_image));
                        }
                        $.each(product.images, function () {
                            var src = self.getImgSrc(product.id, this.name);
                            product.gallery.push(src);
                        });
                        // self.createProductItem(product);
                        self.createProductItem(product);
                        self.items++;
                    });
                    self.page++;
                } else {
                    self.are_more = false;
                }
                self.toggleLoadingStatus(false);
            }, "json");
        },
        getImgSrc: function (id, img) {
            return this.v3_url + '/uploads/web/products/' + id + '/' + img;
        },
        // crea el item y lo pega a la grilla
        createProductItem: function (product)
        {
            var $product = this.$product.clone();

            this.setProductImage($product, product);

            $product.attr('title', product.name);
            this.appendProduct($product);
        },
        setProductImage: function ($product, product) {
            var self = this,
                length = product.gallery.length,
                loaded = 0,
                error = 0,
                imgclass = length > 1 ? 'carousel-item img-wrapper' : 'img-wrapper products-item-fadein';
            var $wrapper = product.gallery.length === 1 ?
                    this.singleWrapper($product, product) :
                    this.carouselWrapper($product, product);
            $wrapper.html('<span class="more"/>');
            $.each(product.gallery, function(i) {
                var img = new Image(),
                    classname = length > 1 && i === 0 ? imgclass + ' active' : imgclass;
                img.onload = function () {
                    var $imgWrapper = $('<div/>', {
                            class: img.height > img.width ? classname + ' taller' : classname,
                            html: img
                        });
                    $wrapper
                        .prepend($imgWrapper);
                    loaded++;
                    if (loaded + error === length) {
                        $product.addClass('loaded')
                            .find('.carousel').bcSwipe();
                    }
                }
                img.onerror = function () {
                    error++;

                    if (loaded + error === length) {
                        if (loaded) {
                            $product.addClass('loaded');
                            if (loaded === 1) {
                                $product.addClass('no-carousel')
                            }
                        } else {
                            $product.fadeOut(function() {
                                $(this).remove();
                                self.checkScrollOffset($(window).height());
                            });
                        }
                    }
                }
                img.alt = product.model_name + ' de Egresados ' + product.name;
                img.src = this;
            });
        },
        singleWrapper: function ($product, product) {
            var href = '/productos/' + product.category_slug + '/' +
                    product.model_slug + '/' + product.slug,
                $wrapper = $('<a href="' + href + '"/>');
            $product.prepend($wrapper);
            return $wrapper;
        },
        carouselWrapper: function ($product, product) {
            var href = '/productos/' + product.category_slug + '/' + product.model_slug + '/' + product.slug,
                $carousel = $('<div/>', {
                    id: 'carousel-' + product.slug,
                    class: 'carousel slide products-item-fadein'
                }),
                $inner = $('<a class="carousel-inner" href="' + href + '"/>'),
                $controls = this.$controls.clone().attr('href', '#carousel-' + product.slug);
            $carousel.append($inner, $controls);
            $product.prepend($carousel);
            return $inner;
        },
        appendProduct: function ($product)
        {
            this.$grid.append($product);
        },
        toggleLoadingStatus: function (loading) {
            this.$loading.addClass('d-none');
            this.$grid.removeClass('d-none');
            this.$spinner.toggleClass('d-none', !loading);
            this.$noResults.removeClass('d-none');
            if (!this.are_more && this.items === 0) {
                $('.products-no-more').removeClass('d-none');
                this.$grid.addClass('d-none');
            }
            this.loading = loading;
            this.first_load = false;
        },
    };

    /* Wrapper de jQuery */
    $.fn.ProductsGrid = function (options) {
        return this.each(function () {
            var data = $(this).data('lb.grid');
            if ( ! data) {
                $(this).data(
                    'lb.grid', // namespace LB
                    (data = new Grid(this, $.extend({}, $.fn.ProductsGrid.defaults, options)))
                );
            }
        });
    };

    /* Default options */
    $.fn.ProductsGrid.defaults = {
        // is_starred: false,
        // on_sale: false,
        model_id: null,
        category_id: null,
        // collection_id: null,
        nocollections: null,
        page: 1,
        $grid: $('.products-grid .items-wrapper'),
        $form: $('.filter-by-tags-form'),
        // $tags_wrapper: $('#tags-wrapper'),
        // $tag: $('.tag'),
        // $show_more_tags: $('.tag-show-more'),
        // loading_msgs_wrapper: $('.loading-msgs'),
        // loading_msgs_time: 1700,
        $loading: $('.products-loading'),
        $noResults: $('.products-no-results'),
        $spinner: $('.products-spinner'),
        query: [],
        v3_url: '//v3core.blue',
        ask_url: '/contacto/ventas/consultar/',
        request_url: '/contacto/ventas/pedir/'
    };

}(jQuery));